module.exports = __webpack_public_path__ + "media/v3/overlay_texture-teal1-38a4f23b.png";